var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-category"},[_c('error',{attrs:{"errors":_vm.categoryError}}),_c('category-form',{attrs:{"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }